import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTheme, useMediaQuery, Box } from '@mui/material';
import DesktopMenu from '../../common/MenuSideBar/DesktopMenu';
import MobileMenu from '../../common/MenuSideBar/MobileMenu';
import { PATH_NAME } from '../../../configs/pathName';
import colorConfigs from '../../../configs/colorConfigs';
import Menu from '../../../api/MenuAPI';

const MenuPage: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const machine_id = localStorage.getItem('machine_id');
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Machine ID from localStorage:", machine_id);
    
    if (!machine_id) {
        console.error("Machine ID is missing, redirecting to home...");
        navigate(PATH_NAME.ROOT); // Redirect if machine_id is missing
    } else {
      navigate(`/menu/${machine_id}`);
    }
  }, [machine_id, navigate]);

  return (
    <Box sx={{background: colorConfigs.secondary}}>
      {machine_id && (isMobile ? <MobileMenu machineId={machine_id} /> : <DesktopMenu machineId={machine_id} />)}
    </Box>
  ); 
};

export default MenuPage;